<template>
  <div>
    <ConfirmPopup
      v-if="showConfirmPopup"
      :popupContext="currentPopupContext"
      @popupEvent="popupEventHandler"
    ></ConfirmPopup>

    <div id="journal" class="teacher-journal" v-if="!journalNew.isEmpty()">
      <v-tooltip
        bottom
        :content-class="tooltipClass"
        v-model="filterBtnTTip"
        max-width="250"
        :position-x="tooltipX"
        :position-y="tooltipY"
      >
        {{ tooltipText }}
      </v-tooltip>
      <v-tooltip
        bottom
        :content-class="infoTooltipClass"
        v-model="infoTooltip"
        max-width="2000"
        :position-x="infoTooltipX"
        :position-y="infoTooltipY"
      >
        {{ infoTooltipText }}
      </v-tooltip>
      <div class="toolbar-wrapper">
        <div class="journal-label">Журнал</div>
      </div>
      <v-row class="col-12 pa-0 ma-0" no-gutters>
        <v-col class="d-flex justify-start" cols="11" v-if="isTeacher">
          <div class="d-flex justify-space-between">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="ma-2"
                  outlined
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  @click="addCol"
                >
                  Додати стовпчик
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in addItems"
                  :key="index"
                  @click="selectType(item)"
                >
                  <v-list-item-title>{{ item.label }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <div v-if="selectedType" class="d-flex justify-space-between">
              <div
                v-if="selectedType.type !== addItemsEnum.AUDIATION"
                class="d-flex justify-space-between ma-2"
              >
                <div>Додати тематичну по урок</div>
                <!-- <span class="nowrap-label">{{ selectedType.label }} з</span> -->
                <!-- <v-text-field
                  class="ma-0 pa-0"
                  v-model="lessonRange.startLabel"
                  hide-details
                ></v-text-field>
                <span>по</span> -->
                <v-text-field
                  class="ma-0 pa-0"
                  v-model="lessonRange.endLabel"
                  hide-details
                ></v-text-field>
              </div>
              <div v-else class="d-flex justify-space-between ma-2">
                <div>Додати стовпчик після</div>
                <div>
                  <v-text-field
                    class="ma-0 pa-0"
                    v-model="lessonRange.endLabel"
                    hide-details
                  ></v-text-field>
                </div>
              </div>
              <v-btn
                class="ma-2"
                outlined
                color="primary"
                max-width="114"
                @click="cancelAddColumn"
              >
                Відмінити
              </v-btn>
              <v-btn
                class="ma-2"
                color="primary"
                max-width="101"
                :disabled="!hasSelectedRange"
                @click="addColumnServer"
              >
                Зберегти
              </v-btn>
            </div>
          </div>
        </v-col>
        <v-col class="d-flex justify-end" cols="1">
          <v-switch
            v-if="isTeacher"
            class="ma-0 pa-0"
            v-model="allowColorTheme"
            hide-details
          ></v-switch>
        </v-col>
      </v-row>
      <v-row class="col-12 pa-0 ma-0" no-gutters>
        <v-col class="d-flex justify-start mb-6">
          <div class="d-flex justify-space-between">
            <v-switch
              class="ma-0 pa-0"
              v-if="!isTeacher"
              v-model="allowColorTheme"
            ></v-switch>
            <v-text-field
              v-if="isTeacher"
              class="ma-0 me-3 pa-0"
              v-model="searchByName"
              append-icon="mdi-magnify"
              label="Знайти учня"
              single-line
              hide-details
            ></v-text-field>
            <v-combobox
              class="ma-0 me-3 pa-0"
              v-model="selectFilter"
              :disabled="operationInProgress"
              :items="filterItems"
              label="Фільтр"
              clearable
              multiple
            ></v-combobox>
          </div>
        </v-col>
        <v-col v-if="isTeacher" lass="d-flex justify-end mb-6">
          <div class="d-flex justify-space-between">
            <div class="nowrap-label ma-2">Показати з:</div>
            <div class="ma-2">
              <v-text-field
                class="ma-0 pa-0"
                hide-details
                :disabled="operationInProgress"
                v-model="startNumber"
              ></v-text-field>
            </div>
            <div class="ma-2">по</div>
            <div class="ma-2">
              <v-text-field
                class="ma-0 pa-0"
                hide-details
                :disabled="operationInProgress"
                v-model="endNumber"
              ></v-text-field>
            </div>
            <v-btn
              class="ma-2"
              :disabled="operationInProgress"
              outlined
              color="primary"
              @click="applyRange"
              >Застосувати</v-btn
            >
          </div>
        </v-col>
      </v-row>
      <v-row v-if="isTeacher" class="col-12 pa-0 ma-0" no-gutters>
        <v-col class="d-flex justify-end" cols="12">
          <div class="d-flex justify-space-between ma-2">
            <span class="nowrap-label ma-2">На сторінці:</span>
            <v-select
              class="page-number ma-0 pa-0"
              :disabled="operationInProgress"
              hide-details
              v-model="pageNum"
              :items="pageItems"
            ></v-select>
            <span class="ma-2">
              {{ rangeLabel }}
            </span>
            <div
              :class="{
                disabled: !hasPrevPagginationPage || operationInProgress,
              }"
              @click="getPrevPage()"
            >
              <v-icon
                medium
                :color="
                  !hasPrevPagginationPage || operationInProgress
                    ? '#f5f5f5'
                    : 'black'
                "
                class="iconStyle"
                >chevron_left</v-icon
              >
            </div>
            <div
              class="toolbar-pagination-pages-nav"
              :class="{
                disabled: !hasNextPagginationPage || operationInProgress,
              }"
              @click="getNextPage()"
            >
              <v-icon
                medium
                :color="
                  !hasNextPagginationPage || operationInProgress
                    ? '#f5f5f5'
                    : 'black'
                "
                class="iconStyle"
                >chevron_right</v-icon
              >
            </div>
          </div>
        </v-col>
      </v-row>

      <div
        class="tbl"
        @mouseover="showTooltip"
        @mouseleave="hideTooltip"
        @mousemove="onMousemoveTooltip"
      >
        <div v-if="operationInProgress" class="progress-bar">
          <div class="progress-line"></div>
        </div>
        <div @click="handleClickInJournal">
          <div v-if="operationInProgress" class="progress-cicular">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
          <div
            class="row"
            :class="{
              'grey lighten-4': indexRow % 2 === 0,
              'in-progress': operationInProgress,
            }"
            v-for="(row, indexRow) of journalNew.displayStructure"
            :style="journalNew.getJournalRowStyles()"
            style="max-width: unset;"
            :key="indexRow"
          >
            <div
              class="cell"
              :indexRow="indexRow"
              :indexColumn="indexColumn"
              :class="{
                'custom-size': item.isCustomHeader,
                sticky: item.sticky,
                'number-lesson': item.isNumber,
                'student-name': item.isName,
                odd: indexRow % 2 === 0,
                even: indexRow % 2 === 1,
                header: indexRow === 0,
                'in-range': journalNew.isInRange(indexColumn),
              }"
              v-for="(item, indexColumn) of row"
              :key="indexColumn"
              :row-index="indexColumn"
              :tooltip-label="item.lessonName"
            >
              <div
                v-if="item.edit"
                class="edit-filde"
                :class="[
                  {
                    'label-wrapper':
                      item.cellType === 'cell' && indexColumn > 1,
                    'right-margin': item.type === addItemsEnum.AUDIATION,
                  },
                  getLabelClass(item.label),
                ]"
              >
                <input
                  class="edit-input set-mark"
                  :class="{
                    invalid:
                      item.label &&
                      item.label.length !== 0 &&
                      !markRule(item.label),
                  }"
                  v-model="item.label"
                  type="text"
                  :disabled="!isTeacher"
                  @input="updateItemVal(item)"
                />
              </div>
              <div
                :class="{
                  'header-cell-label': indexRow === 0,
                }"
                class="cell-label"
                v-else
              >
                <span v-if="item.type === addItemsEnum.AUDIATION">
                  <input
                    class="edit-input"
                    v-model="item.label"
                    type="text"
                    :disabled="!isTeacher"
                    @input="updateNameVal(item)"
                  />
                </span>
                <span
                  v-else
                  :class="[
                    {
                      'label-wrapper':
                        item.cellType === 'cell' &&
                        (indexColumn > 1 || !isTeacher),
                      'theme-wrapper':
                        (item.type === addItemsEnum.THEME ||
                          item.type === addItemsEnum.SEMESTERS) &&
                        item.cellType === 'header',
                    },
                    getLabelClass(item.label),
                  ]"
                >
                  {{ item.label }}
                </span>
                <span
                  class="dot-wrapper"
                  v-if="
                    [addItemsEnum.THEME].indexOf(item.type) !== -1 &&
                    indexRow === 0 &&
                    isTeacher
                  "
                >
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <div class="dots-menu"></div>
                        <div class="dots-menu"></div>
                        <div class="dots-menu"></div>
                      </span>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(menuItem, index) in menuItems"
                        @click="handleThemeItem(item, menuItem.value)"
                        :key="index"
                      >
                        <v-list-item-title class="menu-item">{{
                          menuItem.title
                        }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </span>
                <span
                  class="lesson-remove-ico"
                  v-if="
                    [addItemsEnum.AUDIATION, addItemsEnum.SEMESTERS].indexOf(
                      item.type
                    ) !== -1 &&
                    indexRow === 0 &&
                    isTeacher
                  "
                >
                  <svg
                    name="remove-icon"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 3V4H4V6H5V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V6H20V4H15V3H9ZM7 6H17V19H7V6ZM9 8V17H11V8H9ZM13 8V17H15V8H13Z"
                      fill="#757575"
                    />
                  </svg>
                </span>
                <span v-if="item.cellType === 'header' && item.isName">
                  <svg
                    :class="item.sortDirection === 1 ? 'up' : 'down'"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M7 14L12 19L17 14H7Z" fill="#757575" />
                    <rect x="11" y="5" width="2" height="9" fill="#757575" />
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JournalEventEnum from '@/enums/JournalEventEnum';
import PopupEventEnum from '@/enums/PopupEventEnum';
import JournalTaskEnum from '@/enums/JournalTaskEnum';

import ConfirmPopup from '@/components/View/ConfirmPopup/ConfirmPopup';

const addItemsEnum = {
  NAME: 'name',
  LESSON: 0,
  AUDIATION: 1,
  THEME: 2,
  SEMESTERS: 3,
  ANNUAL: 4,
  CORRECTION: 5,
  THEME_CORRECTION: 6,
};

const cellTypeEnum = {
  HEADER: 'header',
  CELL: 'cell',
};

class BaseCell {
  constructor(type) {
    this.edit = false;
    this.isCustomHeader = ![addItemsEnum.LESSON, addItemsEnum.NAME].includes(
      type
    );
  }
  isEditable() {
    return false;
  }
}

class Cell extends BaseCell {
  constructor(label, id, type, cellType, sticky, isNumber, isName) {
    super(type);
    this.label = label;
    this.id = id;
    this.type = type;
    this.cellType = cellType;
    this.edit = [
      addItemsEnum.AUDIATION,
      addItemsEnum.CORRECTION,
      addItemsEnum.THEME_CORRECTION,
    ].includes(type);
    this.sticky = sticky;
    this.isNumber = isNumber;
    this.isName = isName;
  }

  updateLabel(val) {
    this.label = val;
  }

  toggleEdit() {
    this.edit = !this.edit;
  }

  isEditable() {
    return [
      addItemsEnum.AUDIATION,
      addItemsEnum.CORRECTION,
      addItemsEnum.THEME_CORRECTION,
    ].includes(this.type);
  }
}

class Header extends BaseCell {
  constructor(label, lessonName, id, type, cellType, sticky, isNumber, isName) {
    super(type);
    this.label = label;
    this.lessonName = lessonName;
    this.id = id;
    this.type = type;
    this.cellType = cellType;
    this.sticky = sticky;
    this.sortDirection = -1;
    this.isNumber = isNumber;
    this.isName = isName;
  }
}

class Journal {
  constructor(structure, isTeacher) {
    const defaulCurrentPage = {
      label: 1,
      index: 0,
    };
    this.isTeacher = isTeacher;
    this.rawStructure = structure;
    this.structure = structure;
    this.displayStructure = structure;
    this.NUMBER_TECHNICAL_COLS = isTeacher ? 2 : 0;
    this.numberRows = this.displayStructure[0]
      ? this.displayStructure[0].length
      : 0;
    this.pages = [];
    this.defaulCurrentPage = defaulCurrentPage;
    this.currentPage = defaulCurrentPage;

    this.themeRange = {
      start: -1,
      end: -1,
    };

    const customCell = 152;
    this.cellSizeMap = {
      [addItemsEnum.NAME]: 156, //becouse this.nameSize  divided 2
      [addItemsEnum.LESSON]: 74,
      [addItemsEnum.AUDIATION]: customCell,
      [addItemsEnum.THEME]: customCell,
      [addItemsEnum.SEMESTERS]: customCell,
      [addItemsEnum.ANNUAL]: customCell,
      [addItemsEnum.CORRECTION]: customCell,
      [addItemsEnum.THEME_CORRECTION]: customCell,
    };
    this.cellSize = 74;
    this.nameSize = isTeacher ? 312 : 0;
    this.customCell = 152;

    this.numberOnePage = 10;
    this.numberTwoPage = 20;
  }

  sortColumn(columnIndex, rowIndex) {
    const header = this.displayStructure[rowIndex][columnIndex];
    header.sortDirection = header.sortDirection === 1 ? -1 : 1;
    this.displayStructure[0].forEach((cell, index) => {
      if (index !== columnIndex) {
        cell.sortDirection = 1;
      }
    });
    this.displayStructure.sort((rowA, rowB) => {
      const cellA = rowA[columnIndex];
      const cellB = rowB[columnIndex];
      if (
        cellA.cellType === cellTypeEnum.HEADER ||
        cellB.cellType === cellTypeEnum.HEADER
      ) {
        return 1;
      }
      const valA = cellA.label;
      const valB = cellB.label;
      if (!valA || !valB) {
        return 1;
      }
      if (header.sortDirection === 1) {
        return valA > valB ? 1 : -1;
      }
      return valA > valB ? -1 : 1;
    });
  }

  isEmpty() {
    return this.rawStructure.length === 0;
  }

  calcPages(pageWidh) {
    const numberInPage = Math.round((pageWidh - this.nameSize) / this.cellSize);
    this.numberOnePage = numberInPage;
    this.numberTwoPage = numberInPage * 2;
  }

  getDisplayCell(indexRow, indexColumn) {
    return this.displayStructure[indexRow][indexColumn];
  }

  search(payload) {
    const { types, name } = payload;
    const searchVal = name.toLowerCase();
    this.structure = this.rawStructure.reduce((newStructure, row) => {
      const nameItem = row[1];
      const validRow =
        nameItem.type === addItemsEnum.NAME &&
        nameItem.cellType !== cellTypeEnum.HEADER
          ? nameItem.label.toLowerCase().indexOf(searchVal) !== -1
          : true;
      if (!validRow) {
        return newStructure;
      }
      let filtred = row;
      if (types.length !== 1) {
        filtred = row.filter((item) => {
          return types.includes(item.type);
        });
      }
      newStructure.push(filtred);
      return newStructure;
    }, []);
    const startPage = 0;
    const filtredNumber = this.structure[0].length;
    this._sliceStructure(filtredNumber, startPage);
  }

  isInRange(indexColumn) {
    const inRange =
      this.themeRange.start <= indexColumn &&
      indexColumn <= this.themeRange.end;
    return inRange;
  }

  removeHighlight() {
    this.themeRange.start = -1;
    this.themeRange.end = -1;
  }

  startSelectHeaderByType(rowIndex, type) {
    switch (type) {
      case addItemsEnum.AUDIATION:
        this.selectAudition(rowIndex);
        break;
      case addItemsEnum.THEME:
        this.selectTheme(rowIndex);
        break;
      case addItemsEnum.SEMESTERS:
        this.selectSemest(rowIndex);
        break;
      default:
        this.selectStratagy(rowIndex);
        break;
    }
  }

  selectAudition(rowIndex) {
    this.updateStartThemeRange(rowIndex);
    this.updateEndThemeRange(rowIndex);
  }

  selectTheme(rowIndex) {
    // const headers = this.displayStructure[0];
    // let end = this.NUMBER_TECHNICAL_COLS;
    // for (let i = rowIndex; i > 0; i--) {
    //   const header = headers[i];
    //   if (
    //     [
    //       addItemsEnum.THEME,
    //       addItemsEnum.CORRECTION,
    //       addItemsEnum.THEME_CORRECTION,
    //       addItemsEnum.SEMESTERS,
    //     ].includes(header.type)
    //   ) {
    //     end = i + 1;
    //     break;
    //   }
    // }

    // this.updateStartThemeRange(Math.max(end, this.NUMBER_TECHNICAL_COLS));
    this.updateStartThemeRange(rowIndex);
    this.updateEndThemeRange(rowIndex);
  }

  selectSemest(rowIndex) {
    const headers = this.displayStructure[0];
    const selectHeader = headers[rowIndex];
    if (selectHeader.type !== addItemsEnum.THEME) {
      return;
    }
    const end = this.NUMBER_TECHNICAL_COLS;

    this.updateStartThemeRange(Math.max(end, this.NUMBER_TECHNICAL_COLS));
    this.updateEndThemeRange(rowIndex);
  }

  selectStratagy(rowIndex) {
    if (this.themeRange.start === rowIndex) {
      this.updateStartThemeRange(-1);
      return;
    }

    if (this.themeRange.start === -1) {
      this.updateStartThemeRange(rowIndex);
      return;
    }

    if (this.themeRange.start < rowIndex) {
      this.updateEndThemeRange(rowIndex);
    } else {
      const start = this.themeRange.start;
      this.updateStartThemeRange(rowIndex);
      this.updateEndThemeRange(start);
    }
  }

  getHeaderByRowIndex(rowIndex) {
    const headers = this.displayStructure[0];
    return headers[rowIndex];
  }

  getLessonIdsFromSelectedRange() {
    const selectedLessons = this._getSelectedRange();
    return selectedLessons.map((item) => item.id);
  }

  getDeleteLessonIdsFromSelectedRange() {
    const selectedLessons = this._getSelectedRange();
    const allowDeleteTypes = [
      addItemsEnum.AUDIATION,
      addItemsEnum.THEME,
      addItemsEnum.SEMESTERS,
      addItemsEnum.ANNUAL,
    ];
    return selectedLessons.reduce((ids, item) => {
      if (allowDeleteTypes.includes(item.type)) {
        ids.push(item.id);
      }
      return ids;
    }, []);
  }

  _getSelectedRange() {
    if (this.themeRange.start === -1 || this.themeRange.end === -1) {
      return [];
    }
    const technicalCol = 0;
    const headers = this.displayStructure[0];
    const isLast = headers.length - 1 === this.themeRange.start;
    const begin = isLast
      ? this.themeRange.start
      : this.themeRange.start + technicalCol;

    const end =
      this.themeRange.end === this.themeRange.start
        ? this.themeRange.end + 1
        : this.themeRange.end + 1;

    const selectedLessons = headers.slice(begin, end + technicalCol);

    return selectedLessons;
  }

  updateEndThemeRange(val) {
    this.themeRange.end = val;
  }

  updateStartThemeRange(val) {
    this.themeRange.start = val;
    this.themeRange.end = val;
  }

  addColumn(colIndex, type) {
    this.structure = this.structure.reduce((newStructure, row, index) => {
      const itemType = index === 0 ? addItemsEnum.HEADER : addItemsEnum.LESSON;
      const cell = this.createCellByType(type, itemType);
      const newRow = [...row];
      newRow.splice(colIndex + 1, 0, cell);
      newStructure.push(newRow);
      return newStructure;
    }, []);
    const startPage = 0;
    this._sliceStructure(this.numberRows, startPage);
  }

  createCellByType(cellType, itemType) {
    switch (cellType) {
      case addItemsEnum.AUDIATION: {
        const label = '';
        const id = '';
        return new Cell(label, id, itemType, addItemsEnum.AUDIATION);
      }
    }
  }

  hasPrev() {
    return this.currentPage.index !== 0;
  }

  hasNext() {
    return (
      this.pages.length !== 0 &&
      this.currentPage.index !== this.pages.length - 1
    );
  }

  setOnePageMode() {
    const startPage = 0;
    this._sliceStructure(
      this.numberOnePage + this.NUMBER_TECHNICAL_COLS,
      startPage
    );
  }

  setTwoPageMode() {
    const startPage = 0;
    this._sliceStructure(
      this.numberTwoPage + this.NUMBER_TECHNICAL_COLS,
      startPage
    );
  }

  setAll() {
    this.displayStructure = this.structure;
    this.numberRows = this.displayStructure[0].length;
  }

  getAddSelectedRangeLabels() {
    const { start, end } = this.themeRange;
    const structure = this.displayStructure[0];
    const startLabel = structure[start] ? structure[start].label : '';
    const endLabel = structure[end] ? structure[end].label : '';
    return {
      startLabel,
      endLabel,
    };
  }

  getPages() {
    let numberPages = Math.ceil(
      (this.structure[0].length - this.NUMBER_TECHNICAL_COLS) /
        (this.numberRows - this.NUMBER_TECHNICAL_COLS)
    );
    numberPages = isNaN(numberPages) ? 0 : numberPages;
    const pages = [];
    for (let index = 0; index < numberPages; index++) {
      pages.push({
        label: index + 1,
        index: index,
      });
    }
    this.pages = pages;
    this.currentPage = pages[0] || this.defaulCurrentPage;
    return this.pages;
  }

  navidateToPage(page) {
    this.currentPage = page;
    this._sliceStructure(this.numberRows, page.index);
  }

  moveStartPoistion() {}

  _sliceStructure(number, startPage) {
    const displayStructure = [];
    this.numberRows = number;

    const delta = this.numberRows - this.NUMBER_TECHNICAL_COLS;

    const start =
      startPage === 0
        ? this.NUMBER_TECHNICAL_COLS
        : startPage * delta + this.NUMBER_TECHNICAL_COLS;

    const end = start + delta;
    for (let index = 0; index < this.structure.length; index++) {
      const row = this.structure[index];
      const slicedRow = [];
      if (this.isTeacher) {
        slicedRow = [row[0], row[1]];
      }
      [].push.apply(slicedRow, [...row.slice(start, end)]);
      displayStructure.push(slicedRow);
    }
    this.displayStructure = displayStructure;
  }

  getJournalRowStyles() {
    const headers = this.displayStructure[0];

    const calcWidth = headers.reduce((calcWidth, header) => {
      const size = this.cellSizeMap[header.type] || this.customCell;
      calcWidth += size;
      return calcWidth;
    }, 0);
    const width =
      (this.numberRows - this.NUMBER_TECHNICAL_COLS) * this.cellSize +
      this.nameSize;
    return `width:${calcWidth}px`;
  }
}

function _getCellDefaultValByType(type, evaluationItem) {
  const defaultVal =
    evaluationItem.status === 3 && !evaluationItem.evaluation ? '+' : '-';
  return [
    addItemsEnum.CORRECTION,
    addItemsEnum.THEME_CORRECTION,
    addItemsEnum.AUDIATION,
  ].includes(type)
    ? ''
    : defaultVal;
}

const addItems = [
  { label: 'Тематична', type: addItemsEnum.THEME },
  { label: 'Семестрова', type: addItemsEnum.SEMESTERS },
  { label: 'Інше', type: addItemsEnum.AUDIATION },
];

const themeMenuEnum = {
  EDIT_NAME: 'editName',
  CALCULATE: 'calculate',
  DELETE: 'delete',
};

export default {
  name: 'TeacherJournal',
  components: {
    ConfirmPopup,
  },
  props: {
    journalTask: String,
    isTeacher: Boolean,
    sourceStore: String,
  },
  data() {
    const emptyJournal = this.buildJournalStructure({});
    return {
      showThemeMenu: false,
      themeActivator: null,
      menuItems: [
        // { title: 'Редагувати назву', value: themeMenuEnum.EDIT_NAME },
        { title: 'Розрахувати', value: themeMenuEnum.CALCULATE },
        { title: 'Видалити', value: themeMenuEnum.DELETE },
      ],
      showConfirmPopup: false,
      currentPopupContext: {},
      loaderInterval: null,
      infoTooltipClass: 'info-tooltip-show',
      infoTooltip: null,
      infoTooltipX: 0,
      infoTooltipY: 0,
      infoTooltipText: '',

      updateItemtimerId: null,
      updateItem: {},
      inputRules: [this.markRule],
      addItemsEnum,
      tooltipClass: 'tooltip-hide',
      tooltipText: '',
      allowColorTheme: false,
      addItems,
      selectedType: null,
      searchByName: '',
      pageItems: [10, 20],
      filterItems: [
        { text: 'Уроки', value: addItemsEnum.LESSON },
        { text: 'Тематичні', value: addItemsEnum.THEME },
        { text: 'Семестрові', value: addItemsEnum.SEMESTERS },
        { text: 'Річні', value: addItemsEnum.ANNUAL },
      ],
      selectedItem: addItems[0],
      editMode: false,
      filterBtnTTip: false,
      tooltipX: 0,
      tooltipY: 0,
      journalNew: emptyJournal,
      pages: [],
      showNavigationControls: false,
    };
  },
  computed: {
    operationInProgress: {
      get() {
        return this.$store.getters[`${this.sourceStore}/isLoading`];
      },
      set(val) {
        this.$store.commit(`${this.sourceStore}/journalLoading`, val);
      },
    },

    pageNum: {
      get() {
        return this.$store.getters[`${this.sourceStore}/getNumberLessons`];
      },
      set(val) {
        this.$store.commit(`${this.sourceStore}/setNumberLessons`, val);
      },
    },
    selectFilter: {
      get() {
        const selected = this.$store.getters[
          `${this.sourceStore}/selecteFilter`
        ];
        return selected;
      },
      set(val) {
        this.$store.commit(`${this.sourceStore}/setSelecteFilter`, val);
      },
    },
    hasJournal() {
      return Object.keys(this.journalNew).length !== 0;
    },
    journalData() {
      const journal = this.$store.getters[`${this.sourceStore}/getJournal`];
      return journal;
    },
    hasSelectedRange() {
      const {
        startLabel,
        endLabel,
      } = this.journalNew.getAddSelectedRangeLabels();
      return Boolean(startLabel) && Boolean(endLabel);
    },
    lessonRange() {
      return this.journalNew.getAddSelectedRangeLabels();
    },

    hasPrevPagginationPage() {
      const { start } = this.pagginationRange;
      return start !== 0;
    },
    hasNextPagginationPage() {
      const { end, totalLessons } = this.pagginationRange;
      return end !== totalLessons;
    },
    pagginationRange() {
      return this.$store.getters[`${this.sourceStore}/getLessonRange`];
    },
    rangeLabel() {
      const { start, end, totalLessons } = this.pagginationRange;
      return `${start + 1}-${end} з ${totalLessons} стовпчиків`;
    },
    isLoading() {
      return this.$store.getters[`${this.sourceStore}/isLoading`];
    },
    startNumber: {
      get() {
        const start = this.$store.getters[`${this.sourceStore}/getStartLesson`];
        return start + 1;
      },
      set(val) {
        const rawNum = parseInt(val) - 1;
        const num = isNaN(rawNum) ? '' : rawNum;
        this.$store.commit(`${this.sourceStore}/setStart`, num);
      },
    },
    endNumber: {
      get() {
        const end = this.$store.getters[`${this.sourceStore}/getEndLesson`];
        return end;
      },
      set(val) {
        const rawNum = parseInt(val);
        const num = isNaN(rawNum) ? '' : rawNum;
        this.$store.commit(`${this.sourceStore}/setEnd`, num);
      },
    },
  },
  watch: {
    journalTask(newTask) {
      switch (newTask) {
        case JournalTaskEnum.REFRESH: {
          this.refreshJournal();
          this.emit(JournalEventEnum.REFRESHED_JOURNAL);
          break;
        }
      }
    },
    journalData(newDate) {
      this.journalNew = this.buildJournalStructure(
        newDate,
        this.pagginationRange
      );
      setTimeout(() => {
        const journalSelector = '#journal';
        const journal = document.querySelector(journalSelector);
        if (!journal) {
          console.log(
            `Does not find journal element by selector ${journalSelector}`
          );
          return;
        }
        this.journalNew.calcPages(journal.offsetWidth);
      }, 100);
    },
    searchByName() {
      this.changeFilter();
    },
    // startNumber(newStart) {
    //   const start = parseInt(newStart, 10);
    //   if (!isNaN(start)) {
    //     this.journalNew.moveStartPoistion(start);
    //   }
    // },
    async pageNum() {
      if (this.operationInProgress) {
        return;
      }
      this.$_startLoader();
      try {
        await this.$store.dispatch(`${this.sourceStore}/applyPageNumber`);
      } catch (error) {
        console.log(error);
      }
      this.$_finishLoader();
    },
    async selectFilter() {
      if (this.operationInProgress) {
        return;
      }
      this.$_startLoader();
      try {
        await this.$store.dispatch(`${this.sourceStore}/loadJournal`);
      } catch (error) {
        console.log(error);
      }
      this.$_finishLoader();
    },
  },
  async created() {},
  async mounted() {},
  destroyed() {
    this.$_finishLoader();
  },
  methods: {
    async applyRange() {
      if (this.operationInProgress) {
        return;
      }
      this.$_startLoader();
      try {
        await this.$store.dispatch(`${this.sourceStore}/applyCustomRange`);
      } catch (error) {
        console.log(error);
      }
      this.$_finishLoader();
    },
    async getPrevPage() {
      if (this.operationInProgress) {
        return;
      }
      this.$_startLoader();
      try {
        await this.$store.dispatch(`${this.sourceStore}/applyPrevRange`);
      } catch (error) {
        console.log(error);
      }
      this.$_finishLoader();
    },
    async getNextPage() {
      if (this.operationInProgress) {
        return;
      }
      this.$_startLoader();
      try {
        await this.$store.dispatch(`${this.sourceStore}/applyNextRange`);
      } catch (error) {
        console.log(error);
      }
      this.$_finishLoader();
    },
    getLabelClass(label) {
      if (!this.allowColorTheme) {
        return;
      }
      const val = parseInt(label, 10);
      if (val < 4) {
        return 'red-val';
      }
      if (val >= 4 && val < 7) {
        return 'yellow-val';
      }
      if (val >= 7 && val < 10) {
        return 'blue-val';
      }
      if (val >= 10) {
        return 'green-val';
      }
      return '';
    },
    popupEventHandler(payload) {
      const { type, data } = payload;
      switch (type) {
        case PopupEventEnum.CLOSE_POPUP:
          this.showConfirmPopup = false;
          this.currentPopupContext = {};
          break;
        case PopupEventEnum.CONFIRM:
          this.showConfirmPopup = false;
          this.currentPopupContext = {};
          this.removeColumnServer(data);
        case PopupEventEnum.DECLINE:
          this.showConfirmPopup = false;
          this.currentPopupContext = {};
        default:
          break;
      }
    },
    openConfirm(item) {
      this.currentPopupContext = {
        message: 'Видалити стовпчик',
        item,
      };
      this.showConfirmPopup = true;
    },
    handleThemeItem(cell, action) {
      switch (action) {
        case themeMenuEnum.EDIT_NAME:
          this.$_editCell(cell);
          break;
        case themeMenuEnum.CALCULATE:
          this.$_calcTheme(cell);
          break;
        case themeMenuEnum.DELETE:
          this.removeColumnServer(cell);
          break;
      }
    },
    openThemeMenu(targetElement) {
      this.showThemeMenu = true;
      setTimeout(() => {
        this.themeActivator = targetElement;
      }, 100);
    },
    updateItemVal(item) {
      clearTimeout(this.updateItemtimerId);
      if (!this.markRule(item.label)) {
        return;
      }
      const id = this.updateItem.id;
      if (id && id !== item.id) {
        this.putToJournal(this.updateItem.id, this.updateItem.label);
      }
      this.updateItem = item;
      this.updateItemtimerId = setTimeout(() => {
        this.putToJournal(item.id, item.label);
      }, 1000);
    },
    async putToJournal(lessonId, val) {
      if (this.operationInProgress) {
        return;
      }
      try {
        this.$_startLoader();
        let totalEvaluation = parseInt(val, 10);
        totalEvaluation = isNaN(totalEvaluation) ? 0 : totalEvaluation;
        await this.$store.dispatch('TeacherRoomStore/putToJournal', {
          lessonId,
          totalEvaluation,
        });
      } catch (error) {
        console.error(`get error on put journal error:${error}`);
      }
      this.$_finishLoader();
    },
    markRule(val) {
      const parsed = parseInt(val);
      return /^\d+$/.test(val) ? parsed > 0 && parsed < 13 : false;
    },
    isValidLessonVal(val) {
      const parsed = parseInt(val);
      return /^\d+$/.test(val) ? parsed > 0 && parsed < 10000 : false;
    },
    updateNameVal(item) {
      clearTimeout(this.updateItemtimerId);
      this.updateItemtimerId = setTimeout(() => {
        this.updateColumn(item.id, item.label, item.type);
      }, 1000);
    },
    selectType(item) {
      this.selectedType = item;
      this.showInfoToolTip(item);
    },
    addCol() {
      this.hideInfoTooltip();
    },
    hideInfoTooltip() {
      this.infoTooltipClass = 'info-tooltip-hide';
      this.infoTooltip = false;
      this.infoTooltipText = '';
    },
    showInfoToolTip(item) {
      const table = document.querySelector('.tbl');
      const rect = table.getBoundingClientRect();
      const { text, x, y } = this.$_getTooltipInfoByType(item, rect);
      this.infoTooltipClass = 'info-tooltip-show';
      this.infoTooltipX = x + rect.width / 2;
      this.infoTooltipY = y + 64;
      this.infoTooltipText = text;
      this.infoTooltip = true;
    },
    $_getTooltipInfoByType(item, rect) {
      switch (item.type) {
        case addItemsEnum.THEME:
          return {
            text: 'Оберіть останній стовпчик теми',
            x: rect.x,
            y: rect.y,
          };
        case addItemsEnum.SEMESTERS:
          return {
            text:
              'Оберіть останню тематичну ПЕРШОГО семестру. Семестр 2 та Річна будуть створені автоматично',
            x: rect.x,
            y: rect.y,
          };
        case addItemsEnum.AUDIATION:
          return {
            text: 'Оберіть стовпчик, після якого бажаєте додати новий',
            x: rect.x,
            y: rect.y,
          };
      }
      return '';
    },
    buildJournalStructure(journal, pagginationRange) {
      const structure = this._getJournalStructure(
        journal,
        this.isTeacher,
        pagginationRange
      );
      return new Journal(structure, this.isTeacher);
    },
    _getJournalStructure(journal, isTeacher, pagginationRange) {
      const journalStructure = [];
      if (!journal || Object.keys(journal).length === 0) {
        return journalStructure;
      }
      let headers = [];
      if (isTeacher) {
        const sticky = true;

        headers = [
          this.$_headerItem(
            '№ з/п',
            '',
            '',
            addItemsEnum.NAME,
            sticky,
            true,
            false
          ),
          this.$_headerItem(
            'Прізвище та ім’я учня',
            '',
            '',
            addItemsEnum.NAME,
            sticky,
            false,
            true
          ),
        ];
      }
      const { start } = pagginationRange;
      const idexSummary = {
        [addItemsEnum.LESSON]: (start || 0) + 1,
        [addItemsEnum.THEME]: 1,
        [addItemsEnum.SEMESTERS]: 1,
        [addItemsEnum.ANNUAL]: 1,
      };
      const lessonTypeIndexMap = {};
      journal.lessons.forEach((lesson, index) => {
        lessonTypeIndexMap[index] = lesson.type;
        if (lesson.type === addItemsEnum.CORRECTION && !this.isTeacher) {
          return;
        }
        const label = this.$_getLabelByType(lesson, idexSummary);
        headers.push(
          this.$_headerItem(label, lesson.id, lesson.name, lesson.type)
        );
      });
      journalStructure.push(headers);
      journal.students.sort((studentA, studentB) => {
        const nameA = `${studentA.last_name} ${studentA.first_name}`;
        const nameB = `${studentB.last_name} ${studentB.first_name}`;
        return nameA > nameB ? -1 : 1;
      });
      journal.students.forEach((student, index) => {
        let row = [];
        if (isTeacher) {
          const sticky = true;
          row.push(
            this.$_rowItem(
              index + 1,
              '',
              addItemsEnum.NAME,
              sticky,
              true,
              false
            )
          );
          row.push(
            this.$_rowItem(
              `${student.last_name} ${student.first_name}`,
              student.id,
              addItemsEnum.NAME,
              sticky,
              false,
              true
            )
          );
        }

        student.evaluations.forEach((evaluationItem, index) => {
          const type = lessonTypeIndexMap[index];
          if (type === addItemsEnum.CORRECTION && !this.isTeacher) {
            return;
          }
          const defaultVal = _getCellDefaultValByType(type, evaluationItem);
          row.push(
            this.$_rowItem(
              evaluationItem.evaluation || defaultVal,
              evaluationItem.lesson__id,
              type
            )
          );
        });
        journalStructure.push(row);
        row = [];
      });

      return journalStructure;
    },
    $_getLabelByType({ type, name, semester, lesson_number }, idexSummary) {
      let label = '';
      switch (type) {
        case addItemsEnum.LESSON:
          label = lesson_number
            ? `Урок ${lesson_number}`
            : `Урок ${idexSummary[type]}`;
          break;
        case addItemsEnum.THEME:
          label = name || `Тема`;
          break;
        case addItemsEnum.SEMESTERS:
          label = `Семестр ${semester}`;
          break;
        case addItemsEnum.AUDIATION:
          label = name || `Інше`;
          break;
        case addItemsEnum.ANNUAL:
          label = `Річна`;
          break;
        case addItemsEnum.CORRECTION:
          label = `Скоригована`;
          break;
        case addItemsEnum.THEME_CORRECTION:
          label = `Тем. Cкор.`;
          break;
        default:
          console.error(`get unsuported type ${type}`);
          break;
      }
      idexSummary[type] += 1;
      return label;
    },
    $_headerItem(
      label,
      id,
      name,
      type,
      sticky = false,
      isNumber = false,
      isName = false
    ) {
      return new Header(
        label,
        name,
        id,
        type,
        cellTypeEnum.HEADER,
        sticky,
        isNumber,
        isName
      );
    },
    $_rowItem(
      label,
      id,
      type,
      sticky = false,
      isNumber = false,
      isName = false
    ) {
      return new Cell(
        label,
        id,
        type,
        cellTypeEnum.CELL,
        sticky,
        isNumber,
        isName
      );
    },
    setOnePageMode() {
      this.journalNew.setOnePageMode();
      this._calcNumberPages();
      this.showNavigationControls = true;
    },

    setTwoPageMode() {
      this.journalNew.setTwoPageMode();
      this._calcNumberPages();
      this.showNavigationControls = true;
    },
    setAll() {
      this.journalNew.setAll();
      this._calcNumberPages();
      this.showNavigationControls = false;
    },

    _calcNumberPages() {
      this.pages = this.journalNew.getPages();
    },

    navidateToPage(page) {
      this.journalNew.navidateToPage(page);
    },

    addColumn() {
      this.journalNew.addColumn(0, addItemsEnum.AUDIATION);
    },

    cancelAddColumn() {
      this.selectedType = null;
      this.hideInfoTooltip();
      this.journalNew.removeHighlight();
    },

    async addColumnServer() {
      try {
        if (this.operationInProgress) {
          return;
        }
        const teacherClass = this.$store.getters[
          'TeacherRoomStore/getTeacherClass'
        ];
        const studentGroupeId = this.$store.getters[
          'TeacherRoomStore/getStudentGroupe'
        ];
        const themelessonsIds = this.journalNew.getLessonIdsFromSelectedRange();
        const hasSelectedType = this.selectedType && this.selectedType.type;
        if (themelessonsIds.length === 0 || !hasSelectedType) {
          console.error(
            `Get invalid data ${themelessonsIds} ${this.selectedType}`
          );
          return;
        }
        this.$_startLoader();
        await this.$store.dispatch('TeacherRoomStore/addColumn', {
          student_group: studentGroupeId,
          course: teacherClass.id,
          semester: 0,
          type: this.selectedType.type,
          name: '',
          description: '',
          themelessons: themelessonsIds,
        });

        await this.$store.dispatch('TeacherRoomStore/loadJournal');
        this.cancelAddColumn();
      } catch (error) {
        console.error(`get error on add column ${error}`);
      }
      this.$_finishLoader();
    },

    $_getLoaderEWlement() {
      return document.querySelector('.progress-line');
    },

    $_updateProgressWidth(percent) {
      const element = this.$_getLoaderEWlement();
      if (element) {
        element.style.width = `${percent}%`;
      }
    },

    $_startLoader() {
      this.operationInProgress = true;
      clearInterval(this.loaderInterval);
      const duration = 3 * 1000;
      const updateTime = 20;
      const maxPercents = 90;
      const delta = Math.round(maxPercents / (duration / updateTime));
      let startVal = 0;
      this.loaderInterval = setInterval(() => {
        this.$_updateProgressWidth(startVal);
        startVal += delta;
      }, 100);
    },

    $_finishLoader() {
      this.operationInProgress = false;
      this.$_updateProgressWidth(100);
      clearInterval(this.loaderInterval);
      setTimeout(() => {
        this.$_clearLoader();
      }, 400);
    },

    $_clearLoader() {
      this.$_updateProgressWidth(0);
      clearInterval(this.loaderInterval);
    },

    async updateColumn(id, name, type) {
      const teacherClass = this.$store.getters[
        'TeacherRoomStore/getTeacherClass'
      ];
      const studentGroupeId = this.$store.getters[
        'TeacherRoomStore/getStudentGroupe'
      ];

      const data = {
        student_group: studentGroupeId,
        course: teacherClass.id,
        semester: 0,
        type: type,
        name: name,
        description: '',
        themelessons: [],
      };

      await this.$store.dispatch('TeacherRoomStore/updateColumn', { id, data });
    },
    $_editCell() {
      console.log('need implement edit cell');
    },
    async $_calcTheme(cell) {
      try {
        if (this.operationInProgress) {
          return;
        }
        this.$_startLoader();
        const calcIds = cell.id;
        if (!calcIds) {
          return;
        }
        await this.$store.dispatch('TeacherRoomStore/calculateTheme', {
          id: cell.id,
        });
        await this.$store.dispatch('TeacherRoomStore/loadJournal');
      } catch (error) {
        console.error(`get error on remove column error ${error}`);
      }
      this.$_finishLoader();
    },
    async removeColumnServer(item) {
      try {
        if (this.operationInProgress) {
          return;
        }
        this.$_startLoader();
        const deleteLessonsId = item.id;
        if (!deleteLessonsId) {
          return;
        }
        await this.$store.dispatch('TeacherRoomStore/removeColumn', {
          lessonId: deleteLessonsId,
        });
        await this.$store.dispatch('TeacherRoomStore/loadJournal');
      } catch (error) {
        console.error(`get error on remove column error ${error}`);
      }
      this.$_finishLoader();
    },

    async refreshJournal() {
      try {
        if (this.operationInProgress) {
          return;
        }
        this.$_startLoader();
        await this.$store.dispatch('TeacherRoomStore/loadJournal');
      } catch (error) {
        console.error(`get error on remove column error ${error}`);
      }
      this.$_finishLoader();
    },

    changeFilter() {
      this.pageNum = 'Всі';
      this.setAll();
      let types = [addItemsEnum.NAME];
      types = this.selectFilter.reduce((types, item) => {
        types.push(item.value);
        if (item.value === addItemsEnum.SEMESTERS) {
          types.push(addItemsEnum.CORRECTION);
        }
        if (item.value === addItemsEnum.THEME) {
          types.push(addItemsEnum.THEME_CORRECTION);
        }
        return types;
      }, types);

      this.journalNew.search({
        types,
        name: this.searchByName,
      });
    },

    showTooltip(event) {
      if (this.selectedType !== null) {
        return;
      }
      this.filterBtnTTip = true;
    },
    hideTooltip() {
      if (this.selectedType !== null) {
        return;
      }
      this.filterBtnTTip = false;
    },
    onMousemoveTooltip(event) {
      if (!event || !event.target || this.selectedType !== null) {
        return;
      }

      const isHeader = event.target.classList.contains('header-cell-label');
      const isParentHeader = event.target.parentElement.classList.contains(
        'header-cell-label'
      );
      if (!isHeader && !isParentHeader) {
        this.$_dropTooltipPosition();
        return;
      }
      const header = event.target.closest('.header');
      if (!header) {
        this.$_dropTooltipPosition();
        return;
      }
      const text = header.getAttribute('tooltip-label');
      if (!text) {
        this.$_dropTooltipPosition();
        return;
      }
      this.tooltipText = text;
      this.tooltipX = event.screenX;
      this.tooltipY = event.screenY - 100;

      this.tooltipClass = 'tooltip-show';
      this.showTooltip();
      return;
    },
    $_dropTooltipPosition() {
      this.tooltipClass = 'tooltip-hide';
      this.hideTooltip();
    },
    handleClickInJournal(event) {
      if (!event || !event.target) {
        return;
      }
      this.hideInfoTooltip();
      const { x, y } = event;
      const elements = document.elementsFromPoint(x, y);
      let icon;
      const isRemoveIcon = elements.some((element) => {
        const isRemove = element.getAttribute('name') === 'remove-icon';
        icon = element;
        return isRemove;
      });

      let themeIcon;
      const isThemeMenu = elements.some((element) => {
        const isTheme = element.classList.contains('dot-wrapper');
        themeIcon = element;
        return isTheme;
      });
      const targetElement = event.target.closest('.cell');
      const indexRow = targetElement.getAttribute('indexRow');
      const indexColumn = parseInt(targetElement.getAttribute('indexColumn'));

      const cell = this.journalNew.getDisplayCell(indexRow, indexColumn);
      const rowIndex = parseInt(targetElement.getAttribute('row-index'));
      const isHeader = targetElement.classList.contains('header');
      if (isRemoveIcon) {
        const targetElement = icon.closest('.cell');
        const indexRow = targetElement.getAttribute('indexRow');
        const indexColumn = targetElement.getAttribute('indexColumn');

        const cell = this.journalNew.getDisplayCell(indexRow, indexColumn);
        this.openConfirm(cell);

        return;
      }
      if (isThemeMenu) {
        const targetElement = themeIcon.closest('.cell');
        this.openThemeMenu(targetElement);
      }
      if (
        isHeader &&
        [addItemsEnum.CORRECTION, addItemsEnum.THEME_CORRECTION].includes(
          cell.type
        )
      ) {
        return;
      }
      if (isHeader && this.selectedType) {
        this.journalNew.startSelectHeaderByType(
          rowIndex,
          this.selectedType.type
        );
        return;
      } else if (isHeader && indexColumn === 1) {
        this.journalNew.sortColumn(indexColumn, indexRow);
      }

      if (cell.isEditable() && !cell.edit) {
        cell.toggleEdit();
        return;
      }

      const isLabelNumber = !isNaN(parseInt(cell.label, 10));
      if (
        isLabelNumber &&
        cell.id &&
        !isHeader &&
        !cell.edit &&
        [addItemsEnum.LESSON].includes(cell.type)
      ) {
        this.emit(JournalEventEnum.OPEN_LESSON, { value: cell.id });
      }
    },
    emit(type, data) {
      this.$emit('journalEvent', {
        type,
        data,
      });
    },
  },
};
</script>

<style lang="less">
.theme--light.v-input input,
.theme--light.v-input textarea {
  padding: 5px 0 10px 0;
  color: #f15a22;
}
.toolbar-filter {
  width: 200px;
  height: 78px;
  padding: 20px;

  .v-text-field {
    padding-top: 0;
    margin-top: 0;
  }

  .v-input__slot {
    height: 32px;
  }

  .v-select__selection--comma {
    display: none;
  }

  .v-select__selection--comma:first-child {
    display: block;
  }

  .v-select__selection--comma:not(:only-of-type) {
    &:after {
      content: '...';
    }
  }
}
</style>

<style lang="less" scoped>
.teacher-journal {
  margin-bottom: 50px;
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  ::-webkit-scrollbar-track {
    -webkit-border-radius: 3px;
    border-radius: 3px;
  }
  ::-webkit-scrollbar-thumb {
    -webkit-border-radius: 3px;
    border-radius: 3px;
    background: #117973;
  }
}
.controls-toolbar-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;

    .v-input__control {
      .v-input__slot {
        margin-bottom: 0;
      }
    }
  }
  .select-item {
    display: flex;
    .theme-control-wrapper {
      display: flex;
      margin: 0 0 0 50px;
      width: 550px;
      height: 36px;

      .theme-type-wrapper {
        display: flex;
      }

      .theme-stat-val,
      .theme-end-val {
        pointer-events: none;
        width: 70px;
        margin: 0 8px 0 8px;

        .v-text-field {
          padding: 0;
          margin: 0;
        }
      }

      button {
        margin: 0 0 0 8px;
      }
    }
  }
}
.toolbar-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .journal-label {
    color: #083c39;
    width: 71px;
    height: 25px;
    left: 295px;
    top: 561px;

    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 25px;

    margin: 26px 0 26px 0;
  }
  .toolbar-left-side {
    display: flex;

    .toolbar-search {
      width: 240px;
      height: 78px;
      padding: 20px 0 0 0;
      .v-text-field {
        padding-top: 0;
        margin-top: 0;
      }
    }
    .toolbar-filter {
      width: 200px;
      height: 78px;
      padding: 20px;

      .v-text-field {
        padding-top: 0;
        margin-top: 0;
      }

      .v-input__slot {
        height: 32px;
      }

      .v-select__selection--comma {
        display: none;
      }

      .v-select__selection--comma:first-child {
        display: block;
      }

      .v-select__selection--comma:not(:only-of-type) {
        &:after {
          content: '...';
        }
      }
    }
  }
  .toolbar-right-side {
    display: flex;
  }

  .toolbar-spacer {
    width: 240px;
    height: 78px;
    padding: 20px;
  }

  .toolbar-star-pos {
    display: flex;
    width: 145px;
    height: 78px;
    padding: 20px 0 20px 0;

    .toolbar-star-pos-label {
      font-family: Open Sans;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
      white-space: nowrap;

      width: 89px;
      margin: 5px 0 5px 0;
    }

    .toolbar-star-pos-number {
      width: 44px;

      .v-text-field {
        padding-top: 0;
        margin-top: 0;
      }
    }

    .start-input {
      width: 30px;
    }
  }

  .toolbar-pagination {
    display: flex;
    justify-content: flex-end;
    width: 350px;
    height: 78px;
    padding: 20px 0 20px 0;
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;

    .toolbar-pagination-pages-label {
      width: 107px;
      height: 22px;
      margin: 5px 0 5px 0;
    }

    .pagination-select {
      width: 55px;
      height: 36px;
      margin: 0 0 0 6px;
      line-height: 18px;

      .v-text-field {
        padding-top: 0;
        margin-top: 0;
      }
    }

    .toolbar-pagination-range-label {
      width: auto;
      height: 22px;
      margin: 5px;
    }
    .navigation-wrapper {
      width: 65px;
      display: flex;
      justify-content: flex-end;

      .toolbar-pagination-pages-nav {
        &.disabled {
          pointer-events: none;
          .v-application .black--text {
            color: red;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .toolbar-wrapper {
    display: unset;
  }
}

.tbl {
  // display: flex;
  // flex-direction: column;
  overflow-x: auto;
  width: auto;
  -webkit-box-shadow: 0px 5px 16px 10px rgba(34, 60, 80, 0.2);
  -moz-box-shadow: 0px 5px 16px 10px rgba(34, 60, 80, 0.2);
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.1), 0px 4px 16px rgba(0, 0, 0, 0.1);
}
.row {
  display: flex;
  width: 4000px;
  height: 64px;
  margin: 0;
}

.cell {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 64px;
  width: 74px;

  .label-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    &.red-val {
      background: #ffd3d3;
    }
    &.yellow-val {
      background: #fffae2;
    }
    &.blue-val {
      background: #ebf9ff;
    }
    &.green-val {
      background: #e1ffe0;
    }
  }
  .right-margin {
    margin-right: 30px;
  }

  .cell-label {
    display: flex;
    justify-content: center;
    // flex-direction: column;
    // align-items: flex-start;
    // padding: 20px 20px;
    left: 30.62%;
    right: 63.18%;
    // top: 6.25%;
    bottom: 6.25%;

    .lesson-remove-ico {
      padding: 9px 0 0 0;
    }
  }
  .header-cell-label {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    // padding: 13px 16px;
  }

  .theme-wrapper {
    padding-top: 3px;
  }

  .v-input__slot {
    margin-bottom: 0;
  }

  .edit-filde {
    // margin-top: 10px;
    &.v-input--dense > .v-input__control > .v-input__slot {
      margin-bottom: -10px;
    }
  }
}

.custom-size {
  display: flex;
  justify-content: center;
  width: 152px;
}

.sticky {
  position: absolute;
  width: 234px;
  text-align: left;
  justify-content: end;
}

.number-lesson {
  width: 78px;
  z-index: 1;
  .cell-label {
    padding: 0;
    width: 46px;
    height: 24px;
    left: 16px;
    // top: 20px;
    position: relative;
  }
  &.odd {
    background-color: #f5f5f5;
  }
  &.even {
    background-color: white;
  }
}

.student-name {
  margin-left: 78px;
  z-index: 1;
  &.odd {
    background-color: #f5f5f5;
  }
  &.even {
    background-color: white;
  }
}

.sticky + .cell:not(.student-name) {
  margin-left: 312px;
}

.rotate-180 {
  transform: rotate(180deg);
}

.active-page {
  background-color: #117973;
}
.in-range {
  background-color: #1fadb43d;
}

.tooltip-hide {
  opacity: 0;
}
.tooltip-show {
  opacity: 1;
}

.edit-input {
  width: 88px;
  height: 32px;
  margin: 0 auto;
  margin-top: 6px;
  border: none;
  border: solid 1px #ccc;
  border-radius: 4px;
  text-align: center;
  &.set-mark {
    width: 47px;
    height: 32px;
  }

  &.invalid {
    outline-color: red;
    border: 1px solid red;
  }
}
.edit-input:focus {
  outline-color: #117973;
  border: 1px solid #117973;
  &.invalid {
    outline-color: red;
    border: 1px solid red;
  }
}

.info-tooltip-hide {
  opacity: 0;
}

.info-tooltip-show {
  background-color: #81d8be;
  color: black;
  opacity: 1;
}

.progress-bar {
  width: 100%;
  z-index: 2;
  .progress-line {
    height: 5px;
    width: 0;
    background: #117973;
    position: relative;
    z-index: 2;
  }
}

.up {
  transform: rotate(180deg);
}
.dot-wrapper {
  margin-left: 18px;
}
.dots-menu {
  width: 10px;
  height: 10px;
  background-image: radial-gradient(circle, #616161 3px, transparent 3px);
}

.menu-item {
  cursor: pointer;
}

.nowrap-label {
  white-space: nowrap;
}

.page-number {
  width: 60px;
}

.progress-cicular {
  position: absolute;
  z-index: 10;
  left: 50%;
  padding-top: 100px;
}

.in-progress {
  opacity: 0.5;
  pointer-events: none;
}
</style>
